import SelectInput from '@repo/ui/select-input'

import { PeriodFilter } from '../../../lib/types/models/period/period'
import { t } from '../../../locale/utils'
import { yearsFilterOptions } from '../../../views/pcr-personal-space/utils'

interface Props {
  filter?: PeriodFilter
  onFilterChange: (filter: PeriodFilter) => void
}

export function OtoIndividualPeriodsFilter({ filter, onFilterChange }: Props) {
  return (
    <div className={'flex flex-col gap-3'}>
      <div />

      <SelectInput
        label={t('commissions.filters.year')}
        options={yearsFilterOptions}
        selectedOption={
          filter?.year ? { label: filter.year.toString(), value: filter.year } : undefined
        }
        onChange={(year) => onFilterChange({ ...filter, year })}
      />
    </div>
  )
}
